// src/components/media360/ui/ExperienceCard.jsx
import React, { useMemo } from "react";
import { Button, Icon, Label } from "semantic-ui-react";
import { CopyButton } from "./CopyButton";
import { AudioAttachment } from "./AudioAttachment";

function fmtMode(mode) {
  if (mode === "3d-tb") return "3D-TB";
  if (mode === "3d-sbs") return "3D-SBS";
  return "MONO";
}

export function ExperienceCard({
  exp,
  buildPlayerUrlFromExperience,
  onDeleteExperience,
  disabled,
}) {
  const playerUrl = useMemo(
    () => buildPlayerUrlFromExperience(exp),
    [buildPlayerUrlFromExperience, exp],
  );

  const kindLabel = exp.mediaKind === "image" ? "IMAGEN" : "VIDEO";
  const modeLabel = fmtMode(exp.mode);

  return (
    <div
      style={{
        border: "1px solid #e6e6e6",
        borderRadius: 10,
        padding: 12,
        marginBottom: 12,
        background: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "flex-start",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Icon name={exp.mediaKind === "image" ? "image" : "video"} />
            <strong
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {exp.media?.name}
            </strong>

            <Label size="tiny" basic>
              {kindLabel}
            </Label>
            <Label size="tiny" basic>
              {modeLabel}
            </Label>
            {exp.loop ? (
              <Label size="tiny" color="blue">
                LOOP
              </Label>
            ) : (
              <Label size="tiny" basic>
                NO LOOP
              </Label>
            )}
          </div>

          <div style={{ marginTop: 6, color: "#666", fontSize: 12 }}>
            <span style={{ marginRight: 10 }}>
              Tamaño: {Math.round((exp.media?.size || 0) / 1024)} KB
            </span>
            {exp.media?.updated ? (
              <span>Actualizado: {String(exp.media.updated)}</span>
            ) : null}
          </div>

          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: 12, marginBottom: 6, color: "#444" }}>
              URL del player:
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <CopyButton
                value={playerUrl}
                label="Copiar URL player"
                icon="copy"
                disabled={disabled}
                basic={false}
                color="blue"
              />
              <Button
                size="tiny"
                basic
                disabled={disabled}
                onClick={() =>
                  window.open(playerUrl, "_blank", "noopener,noreferrer")
                }
              >
                <Icon name="external" /> Abrir
              </Button>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: 12, marginBottom: 6, color: "#444" }}>
              URL pública (media):
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <CopyButton
                value={exp.media?.publicUrl}
                label="Copiar URL media"
                icon="copy"
                disabled={disabled}
              />
              <Button
                size="tiny"
                basic
                disabled={disabled}
                onClick={() =>
                  window.open(
                    exp.media?.publicUrl,
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
              >
                <Icon name="external" /> Abrir
              </Button>
            </div>
          </div>

          {/* Subapartado audio */}
          <AudioAttachment audio={exp.audio} disabled={disabled} />
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="tiny"
            color="red"
            basic
            disabled={disabled}
            onClick={() => onDeleteExperience(exp.groupKey)}
            title="Borrar media + audio (si existe)"
          >
            <Icon name="trash" /> Borrar
          </Button>
        </div>
      </div>
    </div>
  );
}
